export function isExternalHref(href: string): boolean {
  return href.startsWith("http") || href.startsWith("mailto:");
}

export function isPlainAnchorHref(href: string): boolean {
  return isExternalHref(href) || href.startsWith("/api/");
}
